import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitovadodaracab() {



  const cardData =
  {
    keyword: 'Mumbai to Vadodara Cab ',
    heading: 'Shambhu Cabs: Mumbai to Vadodara Cab ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Vadodara Cab services, providing safe, comfortable, and hassle-free travel for families, business travelers, corporate groups, and long-distance commuters heading to Vadodara. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and pleasant journey from Mumbai to Vadodara with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Vadodara cab services for travelers seeking comfort, safety, punctuality, and a dependable long-distance travel experience.',

    top: 'Top Places to Visit in Vadodara with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace is the grand architectural jewel of Vadodara and one of the largest private residences in the world. Built by Maharaja Sayajirao Gaekwad III in 1890, the palace is four times the size of Buckingham Palace and blends Indo-Saracenic, Gothic, and Renaissance styles. Its magnificent Darbar Hall, Italian mosaic floors, stained glass windows, and Venetian chandeliers reflect the royal opulence of the Gaekwad dynasty. The palace complex includes lush golf-course-like gardens, royal artifacts, and an impressive collection of paintings, including works by Raja Ravi Varma. Visitors get an immersive experience into Baroda’s royal legacy, making this palace the city's most iconic landmark."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug, spread over 100+ acres, is Vadodara’s largest and most beloved public garden, gifted by Maharaja Sayajirao Gaekwad III. It houses a zoo, a planetarium, a museum, toy train rides, and expansive lawns perfect for family outings. The Baroda Museum and Picture Gallery inside the garden displays ancient sculptures, rare manuscripts, Egyptian artifacts, Mughal miniatures, and impressive zoological specimens. The garden’s wide pathways, tall trees, lake-side spaces, and recreational corners make it a major attraction for nature lovers, students, tourists, and morning walkers seeking a peaceful escape in the heart of the city."
  },
  {
    "title": "EME Temple (Dakshinamurthy Temple)",
    "description": "The EME Temple, maintained by the Indian Army, is one of India’s most unique temples due to its striking, modern aluminum-clad design. Dedicated to Lord Dakshinamurthy, this temple represents different architectural styles from across India—symbolizing national unity. Its domes, towers, and curves reflect influences of Jain, Hindu, Buddhist, and Christian elements. The temple is surrounded by beautifully maintained gardens and is known for its disciplined, peaceful environment. It is not only a spiritual site but also a showcase of modern creativity blended with deep symbolism. Photography rules are strict due to military presence, adding to its disciplined aura."
  },
  {
    "title": "Champaner–Pavagadh Archaeological Park",
    "description": "Located about 45 km from Vadodara, this UNESCO World Heritage Site offers a fascinating journey into medieval Indian history. The complex includes ancient forts, Islamic mosques, Hindu temples, stepwells, palaces, and archaeological remains that date back over 1,000 years. Pavagadh Hill is believed to be part of the mythological mountain carried by Hanuman during the Ramayana. At the top is the revered Mahakali Temple, visited by lakhs of devotees. The mosques—like Jama Masjid and Saher Ki Masjid—feature Indo-Islamic architecture with intricate carvings and minarets. This combination of spirituality, trekking, scenic beauty, and heritage makes Champaner–Pavagadh a must-visit near Vadodara."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a memorial built in 1936 by Maharaja Sayajirao Gaekwad III in honor of the Gaekwad royal family. The structure features striking murals depicting scenes from the Ramayana, Mahabharata, and life stories of various Indian saints. Its tall central tower, beautifully carved windows, and peaceful surroundings create a deeply reflective atmosphere. Kirti Mandir stands as a symbol of the royal family’s contribution to culture, art, and education in Vadodara. The monument’s historical charm and serene vibe attract history enthusiasts, students, and travelers exploring the city’s rich cultural past."
  }
],




"services": [
  {
    "name": "Mumbai Vadodara Taxi",
    "description": "Mumbai Vadodara Taxi offers smooth, reliable, and comfortable long-distance travel between Mumbai and Vadodara (Baroda). With professional chauffeurs, well-maintained vehicles, and flexible travel timings, this service ensures a stress-free intercity journey across the Mumbai–Surat–Vadodara highway route. Ideal for business travelers, families, students, and tourists looking for a hassle-free door-to-door taxi experience for the 400+ km trip."
  },
  {
    "name": "One-Way Cab Mumbai Vadodara",
    "description": "One-Way Cab Mumbai Vadodara provides affordable and convenient single-direction travel for passengers travelling to Vadodara without planning a return trip. This service includes sedans, SUVs, and premium cars with transparent pricing and no hidden charges. Perfect for relocation, business visits, family travel, airport transfers, and last-minute outstation requirements."
  },
  {
    "name": "Affordable Cab Mumbai Vadodara",
    "description": "Affordable Cab Mumbai Vadodara offers budget-friendly taxi solutions for long-distance intercity travel. With economical fare structures, fuel-efficient vehicles, and experienced drivers, the service ensures a pocket-friendly yet comfortable journey. Great for solo travelers, students, and families seeking a low-cost Mumbai to Vadodara cab option."
  },
  {
    "name": "SUV Cab Mumbai Vadodara",
    "description": "SUV Cab Mumbai Vadodara provides spacious, powerful, and comfortable SUVs ideal for long highway journeys. With extra legroom, superior suspension, ample luggage capacity, and strong road grip, SUV taxis are perfect for family groups, corporate travelers, and those seeking a premium travel experience on the Mumbai-Vadodara route."
  },
  {
    "name": "Sedan Cab Mumbai Vadodara",
    "description": "Sedan Cab Mumbai Vadodara offers smooth, economical, and comfortable sedans for long-distance travel. Ideal for 2–3 passengers, sedans ensure good mileage, comfortable seating, and a refined ride quality throughout the 8–10 hour highway journey. This option is popular for everyday travelers, business professionals, and families."
  },
  {
    "name": "Best Taxi Mumbai Vadodara",
    "description": "Best Taxi Mumbai Vadodara delivers high-quality long-distance cab services with well-trained drivers, clean cars, and reliable schedules. Designed for travelers who prefer superior comfort, punctuality, and dependable service, this option ensures a premium travel experience from Mumbai to Vadodara and nearby locations."
  },
  {
    "name": "Corporate Cab Mumbai Vadodara",
    "description": "Corporate Cab Mumbai Vadodara caters to business travelers and corporate employees needing punctual, comfortable, and executive-level taxi services. With fleet options including sedans, SUVs, and luxury cars, this service ensures a productive and stress-free intercity journey for meetings, business trips, and company travel policies."
  },
  {
    "name": "Outstation Cab Mumbai Vadodara",
    "description": "Outstation Cab Mumbai Vadodara provides reliable intercity travel for one-way, round trips, multi-day tours, and extended travel plans. This service is ideal for leisure trips, business travel, and family vacations, offering flexible schedules, experienced chauffeurs, and safe, smooth highway driving throughout the entire route."
  },
  {
    "name": "24×7 Mumbai Vadodara Taxi",
    "description": "24×7 Mumbai Vadodara Taxi ensures round-the-clock availability for late-night departures, early-morning trips, emergency travel, airport pickups, and last-minute bookings. With immediate confirmation and reliable driver support, this service guarantees safe and convenient travel at any time of the day or night."
  },
  {
    "name": "Fast Cab Mumbai Vadodara",
    "description": "Fast Cab Mumbai Vadodara provides quick pickups, rapid confirmations, and efficient highway travel for passengers who need urgent or time-sensitive transportation. With experienced long-route drivers and smooth route management, this service ensures a fast and punctual arrival in Vadodara."
  },
  {
    "name": "Premium Cab Vadodara Trip",
    "description": "Premium Cab Vadodara Trip offers luxury sedans, premium SUVs, and top-tier chauffeur service for travelers seeking superior comfort and style. Ideal for VIP guests, executives, families, and long-distance leisure travelers who prefer a luxury travel experience between Mumbai and Vadodara."
  },
  {
    "name": "Safe Taxi Mumbai Vadodara",
    "description": "Safe Taxi Mumbai Vadodara prioritizes passenger safety with verified drivers, sanitized vehicles, GPS tracking, and careful highway driving practices. Ideal for women travelers, senior citizens, families, and long-distance commuters who want complete security and peace of mind during their trip."
  },
  {
    "name": "Long Distance Cab Mumbai Vadodara",
    "description": "Long Distance Cab Mumbai Vadodara is specially designed for extended highway travel and intercity rides. With comfortable seating, steady driving, and smooth long-duration performance, the service is perfect for covering the 400+ km route with ease and reliability."
  },
  {
    "name": "Family Cab Mumbai Vadodara",
    "description": "Family Cab Mumbai Vadodara offers spacious vehicles, family-friendly interiors, child-friendly seating, luggage capacity, and safe driving for comfortable family travel. Ideal for vacations, hometown visits, or special occasions, ensuring a smooth and pleasant journey for all age groups."
  },
  {
    "name": "Express Highway Cab Vadodara",
    "description": "Express Highway Cab Vadodara provides fast and efficient travel through the Mumbai–Vadodara Express Highway route. The service ensures quick transit, smooth road conditions, and expert drivers familiar with expressway driving, making it perfect for passengers seeking a faster, time-saving ride."
  },
  {
    "name": "Mumbai Vadodara Pickup Drop",
    "description": "Mumbai Vadodara Pickup Drop offers point-to-point transportation from any location in Mumbai to Vadodara and nearby areas. With flexible pickup timings, instant confirmations, and doorstep service, this cab option is perfect for airport transfers, business trips, and personal travel."
  },
  {
    "name": "Mumbai Baroda Cab",
    "description": "Mumbai Baroda Cab provides dedicated taxi services from Mumbai to Baroda (Vadodara), covering one-way, round trip, and multi-day travel needs. With dependable drivers, comfortable vehicles, and transparent pricing, this service is ideal for tourists, families, students, and business travelers heading to Baroda."
  }
],

"tableData": [
  ["Mumbai Vadodara Taxi", "One-Way Cab Mumbai Vadodara"],
  ["Affordable Cab Mumbai Vadodara", "SUV Cab Mumbai Vadodara"],
  ["Sedan Cab Mumbai Vadodara", "Best Taxi Mumbai Vadodara"],
  ["Corporate Cab Mumbai Vadodara", "Outstation Cab Mumbai Vadodara"],
  ["24×7 Mumbai Vadodara Taxi", "Fast Cab Mumbai Vadodara"],
  ["Premium Cab Vadodara Trip", "Safe Taxi Mumbai Vadodara"],
  ["Long Distance Cab Mumbai Vadodara", "Family Cab Mumbai Vadodara"],
  ["Express Highway Cab Vadodara", "Mumbai Vadodara Pickup Drop"],
  ["Mumbai Baroda Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Vadodara Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Vadodara cab services, ideal for business travel, family trips, and smooth long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to ensure a safe and comfortable journey to Vadodara."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Vadodara route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Vadodara cab trip stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel questions, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Intercity Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Vadodara travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Vadodara journey smooth and comfortable."
  }
]



























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Vadodara cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Vadodara cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Vadodara cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Vadodara cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and premium cars ideal for long-distance travel from Mumbai to Vadodara.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Vadodara route?',
    answer: 'Yes, our drivers are licensed, trained, and familiar with the Mumbai to Vadodara route to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Vadodara cab?',
    answer: 'Absolutely. You can select your preferred pickup location in Mumbai and choose any drop-off point in Vadodara.',
  },
  {
    question: 'Is the Mumbai to Vadodara cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab booking services for Mumbai to Vadodara to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Vadodara cab bookings?',
    answer: 'All vehicles are sanitized regularly and our drivers follow strict hygiene and safety protocols throughout your journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Vadodara cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mumbai to Vadodara journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you at every stage of your Mumbai to Vadodara travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Parmar',
    feedback: 'The Mumbai to Vadodara trip with Shambhu Cabs was extremely comfortable. The driver was skilled and very polite.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ketaki Shah',
    feedback: 'Excellent Mumbai to Vadodara cab service! Clean car, smooth ride, and timely pickup by Shambhu Cabs.',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vadodara Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-vadodara-cab.jpg",
  "description": "Shambhu Cabs provides safe, reliable, and affordable Mumbai to Vadodara cab services for one-way or round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, and long-distance journeys. Enjoy 24×7 service, fast travel, express highway options, and convenient pickup-drop from Mumbai to Vadodara/Baroda.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-vadodara-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Vadodara Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Vadodara cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way or round trips, family travel, corporate travel, and long-distance journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop from Mumbai to Vadodara/Baroda."
  />

  <meta
    name="keywords"
    content="Mumbai Vadodara Taxi, One-Way Cab Mumbai Vadodara, Affordable Cab Mumbai Vadodara, SUV Cab Mumbai Vadodara, Sedan Cab Mumbai Vadodara, Best Taxi Mumbai Vadodara, Corporate Cab Mumbai Vadodara, Outstation Cab Mumbai Vadodara, 24×7 Mumbai Vadodara Taxi, Fast Cab Mumbai Vadodara, Premium Cab Vadodara Trip, Safe Taxi Mumbai Vadodara, Long Distance Cab Mumbai Vadodara, Family Cab Mumbai Vadodara, Express Highway Cab Vadodara, Mumbai Vadodara Pickup Drop, Mumbai Baroda Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitovadodaracab;